export default {
  'search-result:results-for': 'Search results for',
  'search-result:results':
    '{count, number} {count, plural, one {Result} other {Results}}',
  'search-result:no-results:header': 'You searched for ‘{term}’',
  'search-result:no-results:sub-header':
    'Try another search term or check the spelling.',
  'search-result:no-param:header': 'Oops!',
  'search-result:page-title':
    'Pets Deli Premium Pet Food | Healthy Dog & Cat Food - Pets Deli', // Kept brand name as is, translated generic terms
  'search-result:page-title:dogs':
    'Pets Deli Dog Food | BARF, Wet Food, Dry Food and more - Pets Deli', // Kept brand name, BARF, translated generic terms
  'search-result:page-title:cats':
    'Premium Cat Food | BARF, Wet Food and Dry Food - Pets Deli', // Kept brand name, BARF, translated generic terms
  'search-result:bestseller-section-title:dogs': 'Popular with dogs',
  'search-result:bestseller-section-title:cats': 'Popular with cats',
};
